<template>
    <div>
        <p class="title">{{product.name}}</p>
        <div class="details">
            <img :src="product.descImg" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            product: {}
        }
    },

    created() {
        let _this = this;
        for(let i = 0; i<this.$store.state.product.length;i++){
            for(let j = 0; j<this.$store.state.product[i].list.length;j++){
                if(this.$store.state.product[i].list[j].id == this.$route.query.id){
                    this.product = this.$store.state.product[i].list[j];
                }
            }
        }
    },

    computed: {
        
    },

    components: {
    },
}

</script>

<style scoped lang='less'>
.title {
    width: 900px;
    margin: 0 auto;
    line-height: 60px;
    font-size: 16px;
    color: #333;
    border-bottom: 1px solid #f4f4f4;
}

.details {
    margin-top: 23px;
    text-align: center;
    padding-bottom: 70px;
    img {
        width: 850px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/productDetails.vue